import { cn } from '@shared/shared-utils';
import { FC } from 'react';

type Properties = {
  className?: string;
};

const PhysicianFinderDisclaimer: FC<Properties> = ({ className }) => {
  return (
    <div
      className={cn('text-[16px] text-[#3D4543] leading-relaxed', className)}
    >
      Organogenesis, Inc. is providing the Physician Finder to help patients
      find a doctor in their area that has experience with Organogenesis.
      Organogenesis is not receiving payment or any other remuneration for this
      service and does not endorse, recommend, and is not responsible for the
      actions of any healthcare professional listed in the Physician Finder.
      This is not a referral for medical services nor is it an endorsement of
      medical services or skills. You are ultimately responsible for the
      selection of a doctor, and it is an important decision that you should
      consider carefully. This locator tool is just one source of information
      available to you. No physician has been paid or received a fee to be
      included in the Physician Finder. Organogenesis does not verify or monitor
      the license, credentials, accreditations or qualifications of any
      physician listed in the Physician Finder, and is not responsible for the
      medical advice of the physicians included in this database. Organogenesis
      is not responsible and shall not be liable to you or others for any
      decision made or action taken by you in reliance on this information
      obtained from the Physician Finder.
    </div>
  );
};

export { PhysicianFinderDisclaimer };
